import { enhancedFilterModelManipulator } from './filter/model.manipulator';
class ExploreModelManipulator {
    getElasticFilters = ({ elasticFilters, }) => {
        if (!(elasticFilters.bool && elasticFilters.bool.filter))
            return [];
        return elasticFilters.bool.filter
            .map(filter => enhancedFilterModelManipulator.convertElasticToFilter({ elasticFilter: filter }))
            .filter(filter => Boolean(filter));
    };
    getMustElasticFilters = ({ elasticFilters, }) => {
        if (!(elasticFilters.bool && elasticFilters.bool.must))
            return [];
        return elasticFilters.bool.must
            .map(filter => enhancedFilterModelManipulator.convertElasticToFilter({ elasticFilter: filter }))
            .filter(filter => Boolean(filter));
    };
    getMustNotElasticFilters = ({ elasticFilters, }) => {
        if (!elasticFilters.bool || !(elasticFilters.bool && elasticFilters.bool.must_not))
            return [];
        return elasticFilters.bool.must_not
            .map(filter => enhancedFilterModelManipulator.convertElasticToFilter({ elasticFilter: filter, negate: true }))
            .filter(filter => Boolean(filter));
    };
    convertElasticToFilters({ elasticFilters }) {
        if (!elasticFilters)
            return [];
        return [
            ...this.getElasticFilters({ elasticFilters }),
            ...this.getMustElasticFilters({ elasticFilters }),
            ...this.getMustNotElasticFilters({ elasticFilters }),
        ];
    }
    convertFiltersToElastic({ filters }) {
        if (filters.length === 0)
            return {
                bool: {
                    must: [],
                    must_not: [],
                    should: [],
                    filter: [],
                },
            };
        const dsl = {
            bool: {
                must: filters
                    .filter(filter => !filter.negate && !filter.isDisabled && !filter.invalid)
                    .map(filter => enhancedFilterModelManipulator.convertToElastic({ filter }))
                    .filter(filter => Boolean(filter)),
                must_not: filters
                    .filter(filter => filter.negate && !filter.isDisabled && !filter.invalid)
                    .map(filter => enhancedFilterModelManipulator.convertToElastic({ filter }))
                    .filter(Boolean),
                should: [],
                filter: [],
            },
        };
        return dsl;
    }
}
export const exploreModelManipulator = new ExploreModelManipulator();
//# sourceMappingURL=explore.manipulator.js.map